import { COVERAGES_BY_ENSURED_TYPE, COVERAGES_CODES } from "../../constants/coverages";

export const filterCoveragesByEnsuredType = (coverages = [], whichEnsure = null) => {
    const allowedCoverages = COVERAGES_BY_ENSURED_TYPE[whichEnsure];
    if (!allowedCoverages) return coverages;
    return coverages.filter(cov => allowedCoverages.indexOf(cov.code) >= 0);
};

export const isSelectedAllCoveragesForMinPrime = (
    allCoverages = [],
    selectedCoverages = [],
    assistantPackage = null
) => {
    const allCoveragesForMinPrime = allCoverages.filter(
        cov =>
            cov.code !== COVERAGES_CODES.ROBBERY &&
            cov.code !== COVERAGES_CODES.DISAPPEAR &&
            cov.code !== COVERAGES_CODES.THEFT_ESPECIAL &&
            cov.code !== COVERAGES_CODES.DISHONESTY
    );
    const selectedCoveragesForMinPrime = selectedCoverages.filter(
        cov =>
            cov.code !== COVERAGES_CODES.ROBBERY &&
            cov.code !== COVERAGES_CODES.DISAPPEAR &&
            cov.code !== COVERAGES_CODES.THEFT_ESPECIAL &&
            cov.code !== COVERAGES_CODES.DISHONESTY
    );
    return (
        allCoveragesForMinPrime.length === selectedCoveragesForMinPrime.length &&
        !!assistantPackage
    );
};
